module.exports = __webpack_public_path__ + "static/media/1-IMG_6754.0de835f2.JPG";